export default "__VITE_ASSET__aynl4eSe__"